import LoginApi from '../api/authentication/loginApi';
import * as types from './actionTypes';
import {startAjaxCall, startAjaxCallError} from './ajaxStatusActions';
import * as pathConstants from '../constants/pathConstants';

export function loginSuccessful(login) {
  return {type: types.LOGIN_SUCCESS, login};
}

export function loginFailure(login) {
  return {type: types.LOGIN_FAILURE, login};
}

export function logoutSuccess(login) {
  return {type: types.LOGOUT_SUCCESS, login};
}

export function logoutEstablishment() {
  return {type: types.LOGOUT_ESTABLISHMENT};
}

export function logoutFilters() {
  return {type: types.CLEAR_FRONT_PAGE_FILTER};
}


export function logoutUser() {
  return {type: types.LOGOUT_USER};
}

export function loginWithLoginGov(){
  return function (dispatch) {
    dispatch(startAjaxCall());
    return LoginApi.realLoginWithLoginGov().then(response => {
      let processedResponse = processLoginResponse(response);
      if (processedResponse.authenticated) {
        const newResponse =
          Object.assign(processedResponse);
        dispatch(loginSuccessful(newResponse));
        return newResponse;
      } else {
        dispatch(startAjaxCallError(processedResponse.statusText));
        dispatch(loginFailure(processedResponse));
        return processedResponse;
      }
    }).catch(error => {
      dispatch(startAjaxCallError(error.message()));
      dispatch(loginFailure({authenticated: false}));
      throw(error);
    });
  };
}

export function login(credentials) {
  return function (dispatch) {
    dispatch(startAjaxCall());
    return LoginApi.login(credentials).then(response => {
      let processedResponse = processLoginResponse(response);
      if (processedResponse.authenticated) {
        const newResponse =
          Object.assign(processedResponse, {password:credentials.password});
        dispatch(loginSuccessful(newResponse));
        LoginApi.saveCredentials(newResponse);
        return newResponse;
      } else {
        dispatch(startAjaxCallError(processedResponse.statusText));
        dispatch(loginFailure(processedResponse));
        return processedResponse;
      }
    }).catch(error => {
      dispatch(startAjaxCallError(error.message()));
      dispatch(loginFailure({authenticated: false}));
      throw(error);
    });
  };
}

function processLoginResponse(response) {
  if (response && response.userId) {
    return Object.assign(response, {authenticated: true});
  } else {
    const logouturl = window.location.origin+pathConstants.pathToLogout;
    window.location = logouturl;
  }
}

export function logout(user) {
  return function (dispatch) {
    dispatch(startAjaxCall());
    return LoginApi.logout(user).then(() => {
      dispatch(logoutSuccess([]));
      dispatch(logoutEstablishment());
      dispatch(logoutFilters());
      dispatch(logoutUser());
    }).catch(error => {
      throw error;
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/loginActions.js
 **/